var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "saas_remind_padding" }, [
    _c("div", { staticClass: "saas_remind" }, [
      _c("div", { staticClass: "text" }, [
        _vm._v(" " + _vm._s(_vm.value.config.title.slice(0, 4)) + " "),
      ]),
      _c("div", { staticClass: "line" }),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notice" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "u-line-1" }, [
          _vm._v("龙年新春佳节至 定格幸福中国年"),
        ]),
        _c("div", { staticClass: "time" }, [_vm._v("2024-01-01 18:00:00")]),
      ]),
      _c("div", { staticClass: "arrow-right" }, [
        _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }